import styled from 'styled-components'

const CustomRadioButton = styled.div`
  display: flex;
  cursor: pointer;
  max-height: 45px;
  align-items: center;
  border-radius: 10px;
  overflow: hidden;
  width: 200px;
  border: 1px solid var(--color-mischka-grey);
`

const Tab = styled.div<{ isSelected: boolean }>`
  background: ${({ isSelected }) => (isSelected ? 'var(--color-button-secondary)' : 'var(--color-white)')};
  color: ${({ isSelected }) => (isSelected ? 'var(--color-text-on-secondary)' : 'var(--color-text-secondary)')};
  padding: 13px 12px;
  max-height: 100%;
  font-size: 14px;
  flex-grow: 1;
  flex-basis: 0;
  white-space: nowrap;
  display: flex;
  justify-content: center;
`

export { CustomRadioButton, Tab }
